import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { format } from 'date-fns'
import { RootState } from '../../../../store'

type GainlossFilter = {
  yearRange: string
}
interface IGainLossSliceState {
  gainlossFilter: GainlossFilter
  expandedRows: { parent: string | number; id: string }[]
}

const initialState: IGainLossSliceState = {
  gainlossFilter: {
    yearRange: format(new Date(), 'yyyy')
  },
  expandedRows: [{ parent: '', id: '' }]
}

const Slice = createSlice({
  name: '@module/accounts/GainLosses',
  initialState,
  reducers: {
    SetGainlossFilter: (state, action: PayloadAction<GainlossFilter>) => {
      return { ...state, gainlossFilter: { ...action.payload } }
    },
    SetGainLossExpandedRowsAfterSearch: (state, action: PayloadAction<{ parent: string | number; id: string }[]>) => {
      return { ...state, expandedRows: [...action.payload] }
    }
  }
})

export const { SetGainlossFilter, SetGainLossExpandedRowsAfterSearch } = Slice.actions
export const getGainLossFilterState = (state: RootState) => state.modules.accounts.gainloss.gainlossFilter
export const getGainLossExpandedRowsAfterSearch = (state: RootState) => state.modules.accounts.gainloss.expandedRows
export default Slice.reducer
